peque.utils = (function () {
  "use strict";

  var getTemplate = function (name) {
    return $("<div/>")
      .html($("#tpl-" + name).html())
      .children();
  };

  /*!
	Underscore.js templates as a standalone implementation.
	JavaScript micro-templating, similar to John Resig's implementation.
	Underscore templates documentation: http://documentcloud.github.com/underscore/#template
	Modifyed by Martin Lundgren */
  (function () {
    "use strict";
    // By default, Underscore uses ERB-style template delimiters, change the
    // following template settings to use alternative delimiters.
    var settings = {
      evaluate: /<%([\s\S]+?)%>/g,
      interpolate: /<%=([\s\S]+?)%>/g,
      escape: /<%-([\s\S]+?)%>/g,
    };
    // When customizing `templateSettings`, if you don't want to define an
    // interpolation, evaluation or escaping regex, we need one that is
    // guaranteed not to match.
    var noMatch = /.^/;
    // Certain characters need to be escaped so that they can be put into a
    // string literal.
    var escapes = {
      "\\": "\\",
      "'": "'",
      r: "\r",
      n: "\n",
      t: "\t",
      u2028: "\u2028",
      u2029: "\u2029",
    };
    for (var p in escapes) {
      escapes[escapes[p]] = p;
    }
    var escaper = /\\|'|\r|\n|\t|\u2028|\u2029/g;
    var unescaper = /\\(\\|'|r|n|t|u2028|u2029)/g;
    var tmpl = function (text, data, objectName) {
      settings.variable = objectName;
      // Compile the template source, taking care to escape characters that
      // cannot be included in a string literal and then unescape them in code
      // blocks.
      var source =
        "__p+='" +
        text
          .replace(escaper, function (match) {
            return "\\" + escapes[match];
          })
          .replace(settings.escape || noMatch, function (match, code) {
            return "'+\n_.escape(" + unescape(code) + ")+\n'";
          })
          .replace(settings.interpolate || noMatch, function (match, code) {
            return "'+\n(" + unescape(code) + ")+\n'";
          })
          .replace(settings.evaluate || noMatch, function (match, code) {
            return "';\n" + unescape(code) + "\n;__p+='";
          }) +
        "';\n";
      // If a variable is not specified, place data values in local scope.
      if (!settings.variable) {
        source = "with(obj||{}){\n" + source + "}\n";
      }
      source =
        "var __p='';var print=function(){__p+=Array.prototype.join.call(arguments, '')};\n" +
        source +
        "return __p;\n";
      var render = new Function(settings.variable || "obj", source);
      if (data) {
        return render(data);
      }
      var template = function (data) {
        return render.call(this, data);
      };
      // Provide the compiled function source as a convenience for build time
      // precompilation.
      template.source =
        "function(" + (settings.variable || "obj") + "){\n" + source + "}";
      return template;
    };
    window._tmpl = tmpl;
  })();

  var createElementFromHTML = function (htmlString) {
    var div = document.createElement("div");
    div.innerHTML = htmlString.trim();
    return div.firstChild;
  };

  String.prototype.replaceAll = function (search, replacement) {
    var target = this;
    return target.replace(new RegExp(search, "g"), replacement);
  };

  var parseTemplate = function (f, data) {
    var html = "",
      result;

    return new Promise((resolve, reject) => {
      if (typeof f == "string") {
        var templateName = "tpl-" + f.replace(/\//, "-").replace(".html", "");

        if (document.querySelector("#" + templateName) == null) {
          throw "Missing template: " + "#" + templateName;
        } else {
          html = document
            .querySelector("#" + templateName)
            .innerHTML.replace(/^[^\/]+\/\*!?/, "")
            .replace(/\*\/[^\/]+$/, "")
            .replaceAll("&lt;%", "<%")
            .replaceAll("%&gt;", "%>")
            .replaceAll('%="">', "%>");
        }
      } else {
        html = f
          .toString()
          .replace(/^[^\/]+\/\*!?/, "")
          .replace(/\*\/[^\/]+$/, "");
      }

      if (typeof data != "undefined") {
        result = _tmpl(html, data);
        result = createElementFromHTML(result);

        resolve(result);
      } else {
        html = createElementFromHTML(result);

        resolve(html);
      }
    });
  };

  const format = (number) => {
    return new Intl.NumberFormat().format(number);
  };

  const strToFloat = function (value) {
    if (Number.isInteger(value) || Number.isFinite(value)) {
      return value;
    }
    if (value.length < 1) {
      return "0";
    }

    let newVal = value.replace(/[^0-9\.,]/g, "");

    // 3.000,24 || 3,000.24
    if (newVal.includes(",") && newVal.includes(".")) {
      // 3.000,24
      if (newVal.indexOf(",") > newVal.indexOf(".")) {
        newVal = newVal.replace(/\./g, "");
        newVal = newVal.replace(",", ".");
      } else {
        // 3,000.24
        newVal = newVal.replace(/,/g, "");
      }
      // 10,000,000 || 10.000.000
    } else if (
      (newVal.match(/,/g) || []).length > 1 ||
      (newVal.match(/\./g) || []).length > 1
    ) {
      newVal = newVal.replace(/,/g, "");
      newVal = newVal.replace(/\./g, "");
      // 3.000 || 3000,51
    } else if (newVal.includes(",") || newVal.includes(".")) {
      const separator = newVal.includes(",") ? "," : ".";

      // 3.000 || 3,000
      if (newVal.split(separator)[1].length === 3) {
        newVal = newVal.replace(separator, "");
      } else {
        // 30,34 || 3000.32
        newVal = newVal.replace(separator, ".");
      }
    }
    return newVal;
  };

  return {
    getTemplate: getTemplate,
    parseTemplate: parseTemplate,
    format: format,
    strToFloat: strToFloat,
  };
})();
